(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptPolReversalDialogController', ReceiptPolReversalDialogController);

    ReceiptPolReversalDialogController.$inject = ['$scope', '$uibModalInstance'];

    function ReceiptPolReversalDialogController ($scope, $uibModalInstance) {
    	var polReversalDlgCtr = this;
    	polReversalDlgCtr.confirm= confirm;
    	function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
